module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/sitebuilder/bravenet_sitebuilder_ecommerce_buy_online.png";